module.exports = __webpack_public_path__ + "img/yesbey.6ea59cd7.svg";